import React, { Component } from 'react';
import PropTypes from 'prop-types';

const AdContainer = (props) => {

    const { playerId } = props;

    return (
        <div id={`ad-container-${playerId}`} className="ad-container"></div>
    );

};

AdContainer.propTypes = {
    /** The unique id of the player */
    playerId: PropTypes.string.isRequired,
};

export default AdContainer;
